export default class CropLand {
    constructor(id, name, polygon, pinColor, strokeColor, fillColor, acre = 0) {
        this.id = id
        this.name = name
        this.polygon = polygon;
        this.pinColor = pinColor;
        this.strokeColor = strokeColor;
        this.fillColor = fillColor;
        this.acre = acre
    }
}